import React from "react";
import { useParams } from "react-router-dom";

function SchoolPage() {
    const { schoolName } = useParams();

    return (
        <div>
            <h1>Welcome to {schoolName.toUpperCase()}</h1>
            <p>This is the main page for {schoolName} on Koku.my.</p>
        </div>
    );
}

export default SchoolPage;
